/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_DescriptionInputs */

const en_contact_description = /** @type {(inputs: Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send us a message and we will get back to you`)
};

const es_contact_description = /** @type {(inputs: Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envianos un mensaje y te responderemos`)
};

/**
* | output |
* | --- |
* | "Send us a message and we will get back to you" |
*
* @param {Contact_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const contact_description = /** @type {((inputs?: Contact_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_description(inputs)
	return es_contact_description(inputs)
});